import { PDFViewer } from "@react-pdf/renderer";
import { Button, Col, Row } from "@themesberg/react-bootstrap";
import React, { useEffect, useState } from "react";
// import { PaymentVoucherPdf } from "./PVPDF";
import { useParams, useNavigate } from "react-router-dom";
import { apiURL, fetchApi, postApi } from "../../../redux/api"; // Ensure this supports FormData
import { Routes } from "../../../routes";
import SupportingDocumentsPv from "./SupportingDocuments";
import NewSupportingDocumentsPv from "./NewSupportducument";
import { PaymentVoucherPdf } from "./PVPDFNew";

const STViewPV = () => {
  const { pv_code } = useParams();
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const [file, setFile] = useState(null);
  const [errorMessage, setErrorMessage] = useState("");
  const [pvList, setPvList] = useState([]);
  const [taxesApplied, setTaxesApplied] = useState([]);

  useEffect(() => {
    if (pv_code) {
      setLoading(true);
      fetchApi(
        `get_new_pv_by_mda?query_type=get_upload_st_pv&id=${pv_code}`
      )
        .then((data) => {
          setPvList(data.result || []);
        })
        .catch((error) => {
          console.error("Error fetching data:", error);
        })
        .finally(() => {
          setLoading(false);
        });
    }
  }, [pv_code]);

  useEffect(() => {
    if (pvList?.length && pvList[0]?.pv_code) {
      setLoading(true);
      fetchApi(`getTaxesAppliedByPv?pv_code=${pvList[0].pv_code}`)
        .then((data) => {
          setTaxesApplied(data?.data || []);
        })
        .catch((error) => {
          console.error("Error fetching taxes applied:", error);
        })
        .finally(() => setLoading(false));
    }
  }, [pvList]);

  const handleSubmit = () => {
    setLoading(true);
    postApi("update_status/by/pv_code", {
      status: "st_approved",
      pv_code: pvList[0].approval_no,
    })
      .then((response) => {
        console.log("Form submitted successfully:", response);
        navigate(Routes.pv.stPvCheckIndex);
      })
      .catch((error) => {
        console.error("Form submission failed:", error);
      })
      .finally(() => {
        setLoading(false);
      });
  };

  // Handle missing `id` case early
  // if (!approval_no) {
  //   return <p>Error: Missing MDA Code</p>;
  // }

  return (
    <div>
      {/* {JSON.stringify({ pvList })} */}
      <Row>
        <Col md={9}>
          <h4>PV No.: {pvList[0]?.pv_no}</h4>
        </Col>
        <Col md={3}>
          <Button
            variant="success"
            className="mt-3"
            // disabled={loading || !file}
            onClick={handleSubmit}
            style={
              pvList[0]?.approval_status !== "Approved"
                ? { display: "none" }
                : { display: "block" }
            }
          >
            {loading ? "Processing..." : "Approve PV"}
          </Button>
        </Col>
        <Col md={8}>
          <PDFViewer
            style={{
              width: "100%",
              height: 1000,
            }}
          >
            <PaymentVoucherPdf form={pvList[0]} taxesApplied={taxesApplied}/>
          </PDFViewer>
        </Col>
        <Col md={3}>
          <NewSupportingDocumentsPv pvInfo={pvList} />
          {/* pvInfo={pvInfo} */}
        </Col>
      </Row>
    </div>
  );
};

export default STViewPV;
